import slugifyLib from 'slugify';

export const slugify = (field: string) => {
  return slugifyLib(field, {
    remove: /[\^%$£`*+~.()'"!:@><&+|{}\/\\]/g,
    lower: true
  });
};
